"use client";

import Link from "next/link";

interface EnrollTourButtonsProps {
  className?: string;
  buttonClassName?: string;
  enrollText?: string;
  tourText?: string;
  enrollUrl?: string;
  tourUrl?: string;
}

export default function EnrollTourButtons({
  className = "flex flex-col sm:flex-row gap-4 justify-center items-center",
  buttonClassName = "bg-school-gold hover:bg-school-gold-dark text-black font-bold py-4 px-8 rounded text-lg transition-colors text-center",
  enrollText,
  tourText,
  enrollUrl = "/contact-us?option=enrol#contact-form",
  tourUrl = "/contact-us?option=tour#contact-form",
}: EnrollTourButtonsProps) {
  if (!enrollText && !tourText) return null;
  return (
    <div className={className} suppressHydrationWarning>
      {enrollText && (
        <Link href={enrollUrl} className={buttonClassName} suppressHydrationWarning>
          {enrollText}
        </Link>
      )}
      {tourText && (
        <Link href={tourUrl} className={buttonClassName} suppressHydrationWarning>
          {tourText}
        </Link>
      )}
    </div>
  );
}

